import { http } from '@/plugins/http';

export async function findOne() {
  const response = await http.get('/mxmed/mappings');
  return response.data;
}

export async function createOrUpdate(data) {
  const response = await http.post('/mxmed/mappings', data);
  return response.data;
}

export async function saveProfessional(data) {
  const response = await http.post('/mxmed/mappings/professionals', data);
  return response.data;
}

export async function removeProfessional(stenciId) {
  const response = await http.delete(`/mxmed/mappings/professionals/${stenciId}`);
  return response.data;
}

export async function syncProfessional(stenciId) {
  const response = await http.post(`/mxmed/mappings/professionals/${stenciId}/sync`);
  return response.data;
}
